import React, { useState, useEffect, useContext } from 'react'
import { useTranslation } from "react-i18next"
import './go.css'
import { LoadingBar, LoadingContext, BufferService, NavigateContext } from 'src/M_Components'
import SimpleApproveBooking from '../../components/utils/simpleApproveBooking'

export default function ApproveBooking({ handleTabClose, toastMessages }) {
  const ctx = useContext(LoadingContext)
  const ctx2 = useContext(NavigateContext)
  const [isLoaded, setIsLoaded] = useState(true)
  const [defaultBooking, setDefaultBooking] = useState(false)
  const { t } = useTranslation()
  const [voyageDict, setVoyageDict] = useState(new Map())
  const [entitiesDict, setEntitiesDict] = useState(new Map())
  const [locationsDict, setLocationsDict] = useState(new Map())
  const [equipmentDict, setEquipmentDict] = useState(new Map())
  const [adminDict, setAdminDict] = useState(new Map())
  const [processDetailsDict, setProcessDetailsDict] = useState(new Map())
  const [linkedQuoteId, setLinkedQuoteId] = useState(null)

  const [formVoyage, setFormVoyage] = useState(true)
  const [formEntities, setFormEntities] = useState(false)
  const [formPortsLocations, setFormPortsLocations] = useState(false)
  const [formEquipments, setFormEquipments] = useState(false)
  const [openConfirmModal, setOpenConfirmModal] = useState(false)

  const [rejectFields, setRejectFields] = useState([])
  const [isChecked, setIsChecked] = useState([])
  const [finalNotes, setFinalNotes] = useState("")
  const [radioButton, setRadioButton] = useState("Wrong fields")
  const [bookingDate, setBookingDate] = useState("")

  const [companies, setCompanies] = useState([])

  const lineId = JSON.parse(sessionStorage.getItem('approveBooking')) ? JSON.parse(sessionStorage.getItem('approveBooking')).Id : null
  const processStatusService = new BufferService('ProcessStatus')
  const bookingV2Service = new BufferService('viewbooking')
  const approveBookingService = new BufferService('viewbookingapproval')
  const approveService = new BufferService('approval')
  const accountService = new BufferService('account')
  const auditService = new BufferService('audit/lastbooking')
  const shipmentChargesService = new BufferService('ShipmentCharges')
  const bookingEquipmentService = new BufferService('BookingEquipment')
  const containerEquipmentService = new BufferService('Equipment', 'secondary')
  const containerEquipmentTypeService = new BufferService('EquipmentType', 'secondary')

  const [shipmentChargesArray, setShipmentChargesArray] = useState([])
  const [chargesRefreshTick, setChargesRefreshTick] = useState(0)

  const refreshShipmentCharges = () => setChargesRefreshTick(t => t + 1)

  const isAdmin = (() => {
    try {
      const names = JSON.parse(sessionStorage.getItem('userRoleNames') || '[]')
      return names.some(n => n === 'Admin' || n === 'SuperAdmin')
    } catch { return false }
  })()

  const [bookingLine, setBookingLine] = useState(null)
  const [shipmentLine, setShipmentLine] = useState([])
  const [transportId, setTransportId] = useState(lineId)
  const [extraValues, setExtraValues] = useState(new Map())

  const [changedList, setChangedList] = useState([])

  const [shipmentObjArray, setShipmentObjArray] = useState([])
  const [bookingEquipmentArray, setBookingEquipmentArray] = useState([])
  const [equipmentClass, setEquipmentClass] = useState('')


  const [selectedLine, setSelectedLine] = useState(null) //guardar

  const [openDrawer, setOpenDrawer] = useState(false)

  const [reprovedRows, setReprovedRows] = useState([])

  const [errorMessage, setErrorMessage] = useState('')

  const [confirmationModal, setConfirmationModal] = useState(false)
  const [approveSuccess, setApproveSuccess] = useState(false)
  const [isApprove, setIsApprove] = useState(false)
  const [openChangedEquipment, setOpenChangedEquipment] = useState(false)

  const [drawerName, setDrawerName] = useState('')

  //user states
  const [id, setId] = useState(sessionStorage.getItem('selectedTab'))
  const [isFirstLoop, setIsFirstLoop] = useState(true)
  const [shipmentArray, setShipmentArray] = useState([])
  const [reject, setReject] = useState('')
  const [accept, setAccept] = useState('')
  const [draft, setDraft] = useState()

  const [leavingPage, setLeavingPage] = useState(false)

  const valueTimeline = [
    { icon: 'pi pi-circle-fill', name: t("TimeLineCreatBook"), color: 'white', connectorColor: 'var(--color-blue)', date: bookingDate },
    { icon: 'pi pi-spin pi-spinner', name: t("TimeLineBookAccp"), color: 'white', connectorColor: 'var(--color-blue)', date: '' },
    { icon: 'pi pi-circle', name: t("TimeLineInsCont"), color: 'white)', connectorColor: 'var(--color-blue)', date: '' },
    { icon: 'pi pi-circle', name: t("TimeLineCreBL"), color: 'white', connectorColor: 'var(--color-blue)', date: '' },
    { icon: 'pi pi-circle', name: t("TimeLineBLAccep"), color: 'White', connectorColor: 'var(--color-blue-light)', date: '' }
  ]

  const cards = [
    { id: 1, name: t("Voyage") },
    { id: 2, name: t("Entities") },
    // { id: 3, name: t("PortsAndLocations") },
    { id: 3, name: t("Ports") },
    // { id: 4, name: t("Details") },
    { id: 5, name: t("Equipments") }
  ]

  const voyage = [
    { label: 'Vessel', tablecode: 'name', code: 'VesselCode', id: 'TransportId' },
    { label: 'Voyage', tablecode: 'voyageNumber', code: 'VoyageNumber', id: 'TransportId' },
  ]

  const entities = [
    { label: 'Client', tablecode: 'accountCode', code: 'ClientCode', id: 'ClientId' },
    { label: 'Client VAT', tablecode: 'accountVATNumber', code: 'ClientVAT', id: 'ClientId' },
    { label: 'Client Reference', tablecode: 'clientReference', code: 'ClientReference' },
    { label: 'Invoice Entity', tablecode: '', code: 'InvoiceCode', id: 'InvoiceId' },
    { label: 'Invoice VAT', tablecode: '', code: 'InvoiceVat', id: 'InvoiceId' },
  ]

  const portsLocations = [
    { label: 'Original Port', tablecode: 'Name', type: 'textfield', code: 'OriginalPortCode', name: 'LocationReceiptPortName', id: 'LocationReceiptId', show: true },
    { label: 'Loading Port', tablecode: 'Name', type: 'textfield', code: 'LoadingPortCode', name: 'LocationLoadingPortName', id: 'LoadingPortId', show: true },
    { label: 'Discharge Port', tablecode: 'Name', type: 'textfield', code: 'DischargePortCode', name: 'LocationDischargePortName', id: 'DischargePortId', show: true },
    { label: 'Final Port', tablecode: 'Name', type: 'textfield', code: 'FinalPortCode', name: 'LocationDeliveryPortName', id: 'LocationDeliveryPortId', show: true },
    { label: 'Original Port Code', tablecode: 'Name', type: 'textfield', code: 'OriginalPortCode', name: 'OriginalPortCode', id: 'LocationReceiptId', show: false, },
    { label: 'Loading Port Code', tablecode: 'Name', type: 'textfield', code: 'LoadingPortCode', name: 'LoadingPortCode', id: 'LoadingPortId', show: false, },
    { label: 'Discharge Port Code', tablecode: 'Name', type: 'textfield', code: 'DischargePortCode', name: 'DischargePortCode', id: 'DischargePortId', show: false, },
    { label: 'Final Port Code', tablecode: 'Name', type: 'textfield', code: 'FinalPortCode', name: 'FinalPortCode', id: 'LocationDeliveryPortId', show: false, },
    { label: 'Transhipment', tablecode: '', type: 'checkbox', code: 'Transhipment', name: 'Transhipment', show: true, },
  ]

  // const details = ['Booking Nr', 'Quote Number']

  const equipments = [
    { label: 'Quantity', tablecode: '', type: 'textfield', code: '' },
    { label: 'Equipment Type', tablecode: '', type: 'combobox', code: '' },
    { label: 'Cargo Description', tablecode: '', type: 'textfield', code: '' },
    { label: 'Load Weight (KG)', tablecode: '', type: 'textfield', code: '' },
    { label: 'Loading Date', tablecode: '', type: 'date', code: '' },
    { label: 'Shipment', tablecode: '', type: 'combobox', code: '' },
    { label: 'SOC', tablecode: '', type: 'checkbox', code: 'SOC' },
    { label: 'IMO', tablecode: '', type: 'checkbox', code: 'IMO' },
    { label: 'Reefer', tablecode: '', type: 'checkbox', code: 'Reefer' },
    { label: 'Open Top/FLAT', tablecode: '', type: 'checkbox', code: 'OpenTop' },
    { label: 'RORO', tablecode: '', type: 'checkbox', code: 'RORO' },
  ]

  const extraValuesArray = [
    { label: 'transport id', create: 'TransportId', edit: 'TransportId' },
    { label: 'Original Port id', create: 'LocationReceiptId', edit: 'LocationReceiptId' },
    { label: 'Loading Port id', create: 'LoadingPortId', edit: 'LoadingPortId' },
    { label: 'Discharge Port id', create: 'DischargePortId', edit: 'DischargePortId' },
    { label: 'Final Port id', create: 'LocationDeliveryPortId', edit: 'LocationDeliveryPortId' },
    { label: 'Client Id', create: 'ClientId', edit: 'ClientId' },
    // { label: 'Waiting for Approval id', create: 'ProcessStatusId', edit: 'ProcessStatusId' },
    { label: 'BookingNumber', create: 'BookingNumber', edit: 'BookingNumber' },
    { label: 'UserCompanyId', create: 'UserCompanyId', edit: 'UserCompanyId' },
    { label: 'InvoiceId', create: 'UserCompanyId', edit: 'InvoiceId' },
  ]

  const fieldsInDrawerEquipment = ['temp', 'Prefix', 'Number', 'CheckDigit', 'Payload', 'Tare', 'onOff', 'DimensionsWidth', 'DimensionsHeight', 'DimensionsLength', 'Front', 'Back', 'Right', 'Left', 'Height', 'Brand', 'Model', 'Chassis',]
  const fieldsInDrawerShipment = ['IdCommodity', 'CommodityCode', 'CommodityName', 'IdDangerousGoods', 'FlashPT', 'PackagingGroup']


  const sessionKeys = ['extraValues', 'transportId', 'bookingLine', 'bookingDate', 'radioButton', 'finalNotes', 'isChecked', 'rejectFields', 'equipmentDict', 'locationsDict', 'entitiesDict', 'voyageDict', 'defaultBooking', 'formVoyage', 'formEntities', 'formPortsLocations', 'formEquipments', 'shipmentObjArray', 'reprovedRows', 'reject', 'accept', 'shipmentArray', 'companies', 'changedList', 'draft', 'shipmentChargesArray', 'bookingEquipmentArray', 'adminDict', 'processDetailsDict']

  useEffect(() => {
    if (isFirstLoop) {
      ctx.setIsLoad(true)
      sessionStorage.removeItem('contextLine')
      sessionStorage.removeItem('approveBooking')
      getSessionStorageData(id)
      setIsFirstLoop(false)
      sessionStorage.setItem(`tab${id}`, JSON.stringify(sessionKeys))
    }
    // eslint-disable-next-line
  }, [])

  // eslint-disable-next-line
  useEffect(() => {
    const newId = sessionStorage.getItem('selectedTab')
    if (newId !== id) {
      setId(newId)
      getSessionStorageData(newId)
    }
  })

  useEffect(() => {
    sessionKeys.forEach((key) => {
      sessionStorageMachine(id, key, key)
    })
    // }, [id, formVoyage, formEntities, formPortsLocations, formDetails, formEquipments])
    // eslint-disable-next-line
  }, [id, extraValues, transportId, bookingLine, bookingDate, radioButton, finalNotes, isChecked, rejectFields, equipmentDict, locationsDict, entitiesDict, voyageDict, defaultBooking, formVoyage, formEntities, formPortsLocations, formEquipments, shipmentObjArray, reprovedRows, reject, accept, shipmentArray, companies, changedList, draft, shipmentChargesArray, bookingEquipmentArray, adminDict, processDetailsDict])

  const sessionStorageMachine = (id, key, value) => {
    // eslint-disable-next-line
    if (eval(value) instanceof Map) {
      // eslint-disable-next-line
      sessionStorage.setItem(`${id}${key}`, JSON.stringify(Array.from(eval(value))))
    } else {
      // eslint-disable-next-line
      sessionStorage.setItem(`${id}${key}`, JSON.stringify(eval(value)))
    }
  }

  const getSessionStorageData = (sessionID) => {
    const tempVD = JSON.parse(sessionStorage.getItem(`${sessionID}voyageDict`))
    const tempED = JSON.parse(sessionStorage.getItem(`${sessionID}entitiesDict`))
    const tempLD = JSON.parse(sessionStorage.getItem(`${sessionID}locationsDict`))
    const tempEQD = JSON.parse(sessionStorage.getItem(`${sessionID}equipmentDict`))
    const tempRF = JSON.parse(sessionStorage.getItem(`${sessionID}rejectFields`))
    const tempIsCH = JSON.parse(sessionStorage.getItem(`${sessionID}isChecked`))
    const tempFN = JSON.parse(sessionStorage.getItem(`${sessionID}finalNotes`))
    const tempRB = JSON.parse(sessionStorage.getItem(`${sessionID}radioButton`))
    const tempBD = JSON.parse(sessionStorage.getItem(`${sessionID}bookingDate`))
    const tempBL = JSON.parse(sessionStorage.getItem(`${sessionID}bookingLine`))
    const tempTI = JSON.parse(sessionStorage.getItem(`${sessionID}transportId`))
    const tempEXV = JSON.parse(sessionStorage.getItem(`${sessionID}extraValues`))
    const tempDB = JSON.parse(sessionStorage.getItem(`${sessionID}defaultBooking`))
    const frmVoyage = JSON.parse(sessionStorage.getItem(`${sessionID}formVoyage`))
    const frmEntities = JSON.parse(sessionStorage.getItem(`${sessionID}formEntities`))
    const frmPortsLocations = JSON.parse(sessionStorage.getItem(`${sessionID}formPortsLocations`))
    // const frmDetails = JSON.parse(sessionStorage.getItem(`${sessionID}formDetails`))
    const frmEquipments = JSON.parse(sessionStorage.getItem(`${sessionID}formEquipments`))
    const tempSOA = JSON.parse(sessionStorage.getItem(`${sessionID}shipmentObjArray`))
    const tempRR = JSON.parse(sessionStorage.getItem(`${sessionID}reprovedRows`))
    const tempR = JSON.parse(sessionStorage.getItem(`${sessionID}reject`))
    const tempA = JSON.parse(sessionStorage.getItem(`${sessionID}accept`))
    const tempSA = JSON.parse(sessionStorage.getItem(`${sessionID}shipmentArray`))
    const tempC = JSON.parse(sessionStorage.getItem(`${sessionID}companies`))
    const tempCL = JSON.parse(sessionStorage.getItem(`${sessionID}changedList`))
    const tempD = JSON.parse(sessionStorage.getItem(`${sessionID}draft`))
    const tempSCA = JSON.parse(sessionStorage.getItem(`${sessionID}shipmentChargesArray`))
    const tempBEA = JSON.parse(sessionStorage.getItem(`${sessionID}bookingEquipmentArray`))
    const tempAD = JSON.parse(sessionStorage.getItem(`${sessionID}adminDict`))
    const tempPDD = JSON.parse(sessionStorage.getItem(`${sessionID}processDetailsDict`))

    if (tempSOA || tempEXV || tempTI || tempBL || tempBD || tempRB || tempFN || tempIsCH || tempRF || tempEQD || tempLD || tempED || tempVD || tempDB || frmVoyage || frmEntities || frmPortsLocations || frmEquipments || tempRR || tempA || tempR || tempSA || tempC || tempCL || tempD || tempSCA) {
      setVoyageDict(new Map(tempVD))
      setEntitiesDict(new Map(tempED))
      setLocationsDict(new Map(tempLD))
      setEquipmentDict(new Map(tempEQD))
      setRejectFields(tempRF)
      setIsChecked(tempIsCH)
      setFinalNotes(tempFN)
      setRadioButton(tempRB)
      setBookingDate(tempBD)
      setBookingLine(tempBL)
      setTransportId(tempTI)
      setExtraValues(new Map(tempEXV))
      setFormVoyage(frmVoyage)
      setDefaultBooking(tempDB)
      setFormEntities(frmEntities)
      setFormPortsLocations(frmPortsLocations)
      // setFormDetails(frmDetails)
      setFormEquipments(frmEquipments)
      setShipmentObjArray(tempSOA)
      setIsLoaded(false)
      setReprovedRows(tempRR)
      setShipmentArray(tempSA)
      setAccept(tempA)
      setReject(tempR)
      setCompanies(tempC)
      setChangedList(tempCL)
      setDraft(tempD)
      if (tempSCA) setShipmentChargesArray(tempSCA)
      if (tempBEA) setBookingEquipmentArray(tempBEA)
      if (tempAD) setAdminDict(new Map(tempAD))
      if (tempPDD) setProcessDetailsDict(new Map(tempPDD))
      ctx.setIsLoad(false)
      return
    }
    get()
  }

  function toJSONLocal(date) {
    return date.slice(0, 10)
  }

  function reformatDate(dateStr) {
    var dArr = dateStr.split("-")  // ex input: "2010-01-18"
    return dArr[2] + "/" + dArr[1] + "/" + dArr[0].substring(0) //ex output: "18/01/2010"
  }

  const get = () => {
    let rejectString
    let approvedString
    let draftString
    // let tempOldBooking = {}
    processStatusService.get().then(status => {
      if (status.name === 'AxiosError') {
        toastMessages('error', '', status.message)
        handleTabClose(JSON.parse(id))
        ctx.setIsLoad(false)
        return
      }
      status.Items.forEach(st => {
        if (st.StatusName === 'Approved') {
          approvedString = st.Id
          setAccept(approvedString)
        }
        if (st.StatusName === 'Rejected') {
          rejectString = st.Id
          setReject(rejectString)
        }
        if (st.StatusName === 'Draft') {
          draftString = st.Id
          setDraft(draftString)
        }
      })

      let tempCompanies = JSON.parse(sessionStorage.getItem('companies'))
      setCompanies(tempCompanies)

      approveBookingService.getId(lineId).then(data => {
        if (data.name === 'AxiosError') {
          handleTabClose(JSON.parse(id))
          ctx.setIsLoad(false)
          toastMessages('error', '', data.message)
          return
        }

        data.ShipmentPlusList = data.ShipmentPlusList.sort((a, b) => a.Shipment.Order === b.Shipment.Order ? a.Shipment.TransportKey - b.Shipment.TransportKey : a.Shipment.Order - b.Shipment.Order)
        // console.log("dataBooking", data)
        setShipmentLine(data.ShipmentPlusList)
        setBookingLine(data.Booking)
        auditService.getId(transportId).then(audit => {
          const tempMap = new Map(Object.entries(audit)) || new Map()
          tempMap.set('0', [])

          const dataBooking = data.Booking

          const newAdminDict = new Map()
          newAdminDict.set('SubAccountId', dataBooking.SubAccountId || null)
          newAdminDict.set('SubAccountCode', dataBooking.SubAccountCode || '')
          newAdminDict.set('ShipperId', dataBooking.ShipperId || null)
          newAdminDict.set('ShipperCode', dataBooking.ShipperCode || '')
          newAdminDict.set('ConsigneeId', dataBooking.ConsigneeId || null)
          newAdminDict.set('ConsigneeCode', dataBooking.ConsigneeCode || '')
          newAdminDict.set('NotifyId', dataBooking.NotifyId || null)
          newAdminDict.set('NotifyCode', dataBooking.NotifyCode || '')
          newAdminDict.set('AgentId', dataBooking.AgentId || null)
          newAdminDict.set('AgentCode', dataBooking.AgentCode || '')
          newAdminDict.set('ExternalLineId', dataBooking.ExternalLineId || null)
          newAdminDict.set('ExternalLineCode', dataBooking.ExternalLineCode || '')
          newAdminDict.set('PreCarriageId', dataBooking.PreCarriagePortId || null)
          newAdminDict.set('PreCarriageName', dataBooking.PreCarriagePortName || '')
          newAdminDict.set('OnCarriageId', dataBooking.OnCarriagePortId || null)
          newAdminDict.set('OnCarriageName', dataBooking.OnCarriagePortName || '')
          newAdminDict.set('SecondTransportId', dataBooking.SecondTransportId || null)
          newAdminDict.set('SecondVoyageNumber', dataBooking.SecondVoyageNumber || '')
          newAdminDict.set('SecondVesselCode', dataBooking.SecondVesselCode || '')
          newAdminDict.set('SecondTradeCode', dataBooking.SecondTradeCode || '')
          newAdminDict.set('SecondTradeLineCode', dataBooking.SecondTradeLineCode || '')
          newAdminDict.set('SecondTradeName', dataBooking.SecondTradeName || '')
          newAdminDict.set('SecondTradeBound', dataBooking.SecondTradeBound || '')
          newAdminDict.set('ShippingConditionId', dataBooking.ShippingConditionId || null)
          newAdminDict.set('ShippingConditionCode', dataBooking.ShippingConditionCode || '')
          newAdminDict.set('CurrencyId', dataBooking.CurrencyId || null)
          newAdminDict.set('CurrencyCode', dataBooking.CurrencyCode || '')
          newAdminDict.set('IncotermsId', dataBooking.IncotermsId || null)
          newAdminDict.set('IncotermsCode', dataBooking.IncotermsCode || '')
          newAdminDict.set('CustomStatusId', dataBooking.CustomStatusId || null)
          newAdminDict.set('CustomStatusCode', dataBooking.CustomStatusCode || '')
          newAdminDict.set('BLNumber', dataBooking.BLNumber || '')
          newAdminDict.set('Mrn', dataBooking.Mrn || '')
          newAdminDict.set('DocumentQuantity', dataBooking.DocumentQuantity ?? null)
          setAdminDict(newAdminDict)

          addValue('QuoteName', data.Booking.QuoteName, extraValues, setExtraValues)

          if(data.Booking.QuoteId !== null || data.Booking.QuoteId !== undefined) {
            setLinkedQuoteId(data.Booking.QuoteId)
          }

          if (dataBooking.ProcessStatusId === approvedString || dataBooking.ProcessStatusId === rejectString) {
            handleTabClose(JSON.parse(id))
            toastMessages('error', '', t('BookingAlreadyChecked'))
            ctx.setIsLoad(false)
            return
          }

          // console.log('idREJECTED', dataBooking.ProcessStatusId, rejectString)
          if (dataBooking.ProcessStatusId === rejectString) {

            if (!dataBooking.ApprovalId) return
            approveService.getId(dataBooking.ApprovalId).then(dataRejected => {
              if (dataRejected.name === 'AxiosError') {
                toastMessages('error', '', dataRejected.message)
                handleTabClose(JSON.parse(id))
                ctx.setIsLoad(false)
                return
              }
              const tempDescription = JSON.parse(atob(dataRejected.Description))
              // console.log('DATA REJECTED', tempDescription)
              tempDescription.RejectFields.forEach(rejected => {
                setIsChecked(prev => [...prev, rejected.key])
              })
              setRejectFields(tempDescription.RejectFields)
              setReprovedRows(tempDescription.ReprovedRows)
              setFinalNotes(tempDescription.Notes)
            })
          }

          if (dataBooking.CreatedOn !== "") {
            const tempDate = reformatDate(toJSONLocal(dataBooking.CreatedOn))
            setBookingDate(tempDate)
          }

          voyage.forEach(obj => {
            addValue(obj.label, dataBooking[obj.code], voyageDict, setVoyageDict)
          })
          entities.forEach(obj => {
            addValue(obj.code, dataBooking[obj.code], entitiesDict, setEntitiesDict)
          })

          tempCompanies.forEach(obj => {
            if (obj.Id === dataBooking.UserCompanyId) {
              addValue('Company', obj.Code, entitiesDict, setEntitiesDict)
              addValue('UserCompanyId', obj.Id, extraValues, setExtraValues)
            }
          })

          portsLocations.forEach(obj => {
            // console.log("das", obj)
            if (obj.type === 'checkbox' && !(dataBooking[obj.code] === true || dataBooking[obj.code] === false)) {
              if (dataBooking[obj.code] === 'Y' || dataBooking[obj.code] === 'S') {
                addValue(obj.label, true, locationsDict, setLocationsDict)
              } else {
                addValue(obj.label, false, locationsDict, setLocationsDict)
              }
            } else {
              addValue(obj.label, dataBooking[obj.name], locationsDict, setLocationsDict)
            }
          })
          extraValuesArray.forEach(obj => {
            addValue(obj.label, dataBooking[obj.edit], extraValues, setExtraValues)
            addValue('id', lineId, extraValues, setExtraValues)
          })
          let tempEquipmentIndex = 1
          let tempEquipmentIndexes = new Map()
          let tempShipmentArray = []
          let tempArrayObj = []
          let masterIndex = 0
          data.ShipmentPlusList.forEach((shipments, shipIndex) => {
            shipments.ShipmentDetailPlusList.filter(sd => sd.ShipmentDetail && sd.BookingEquipment && sd.EquipmentType).forEach((shipmentsDetails, index) => {
              tempEquipmentIndex++
              let tempToUseEquipmentIndex = tempEquipmentIndex
              let tempEquipment = 'yes'
              if (!tempEquipmentIndexes.get(shipmentsDetails.BookingEquipment.Id)) {
                tempEquipmentIndexes.set(shipmentsDetails.BookingEquipment.Id, tempToUseEquipmentIndex)
              } else {
                tempToUseEquipmentIndex = tempEquipmentIndexes.get(shipmentsDetails.BookingEquipment.Id)
                tempEquipment = 'no'
                }

              masterIndex++
              setEquipmentClass(shipmentsDetails.EquipmentClass?.EquipmentCode)
              let tempObj = {
                'id': masterIndex,
                'Quantity': '1',
                'shipOrder': shipments.Shipment.Order,
                'shipTransOrder': shipments.Shipment.TransportKey,
                'shipmentStatus': shipments.Shipment.DbStatus,
                'shipmentDetailsStatus': shipmentsDetails.ShipmentDetail.DbStatus,
                'bookingEquipmentStatus': shipmentsDetails.BookingEquipment.DbStatus,
                'ShipmentId': shipments.Shipment.Id,
                'ShipmentDetailsId': shipmentsDetails.ShipmentDetail.Id,
                'bookingEquipmentId': shipmentsDetails.BookingEquipment.Id,
                'EquipmentTransportKey': shipmentsDetails.BookingEquipment.TransportKey,
                'EquipmentIndex': tempToUseEquipmentIndex,
                'EquipmentTypeId': shipmentsDetails.EquipmentType.Id,
                'Equipment Type': `${shipmentsDetails.EquipmentType?.EquipmentTypeLenght || ''}${shipmentsDetails.EquipmentType.EquipmentTypeCode}`,
                'EquipmentClassCode': shipmentsDetails?.EquipmentClass?.EquipmentCode,
                // 'Cargo Description': shipmentsDetails.ShipmentDetail.Description ? shipmentsDetails.ShipmentDetail.Description : '',
                'NrPackage': shipmentsDetails.ShipmentDetail?.Package,
                'Description': shipmentsDetails.ShipmentDetail?.Description,
                'Weight': shipmentsDetails.ShipmentDetail?.Weight,
                'Measurements': shipmentsDetails.ShipmentDetail?.Measures,

                'Cargo Description': shipmentsDetails.BookingEquipment.GoodsDetails ? shipmentsDetails.BookingEquipment.GoodsDetails : '',
                // 'Load Weight (KG)': shipmentsDetails.ShipmentDetail.Weight ? shipmentsDetails.ShipmentDetail.Weight : '',
                'Load Weight (KG)': shipmentsDetails.BookingEquipment.TransportDetails ? shipmentsDetails.BookingEquipment.TransportDetails : '',
                'IMO': shipments.Shipment.IMODangerGoods ? shipments.Shipment.IMODangerGoods : false,
                'Loading Date': shipmentsDetails?.BookingEquipment?.LoadingDate ? shipmentsDetails?.BookingEquipment?.LoadingDate.slice(0, shipmentsDetails?.BookingEquipment?.LoadingDate?.search('T') || '') : '',
                'Shipment': shipments.Shipment.TransportKey,
                'SOC': shipmentsDetails.BookingEquipment.SOC === 'Y' ? true : false,
                'FlashPT': shipments.Shipment.FlashPT ? shipments.Shipment.FlashPT : "",
                'PackagingGroup': shipments.Shipment.PackingGroup ? shipments.Shipment.PackingGroup : "",
                'Reefer': shipmentsDetails.EquipmentType.EquipmentTypeCode.search('RF') !== -1 || shipmentsDetails.EquipmentType.EquipmentTypeCode.search('HR') !== -1 ? true : false,
                'onOff': shipments.Shipment.Temp !== 0 && shipments.Shipment.Temp !== undefined && shipments.Shipment.Temp !== null ? true : false,
                'temp': shipments.Shipment.Temp,
                'Brand': shipmentsDetails.BookingEquipment.Brand,
                'Model': shipmentsDetails.BookingEquipment.Model,
                'Chassis': shipmentsDetails.BookingEquipment.Chassis,
                'RORO': shipmentsDetails.EquipmentType.EquipmentTypeCode.search('RORO') !== -1 ? true : false,
                'OpenTop': shipmentsDetails.EquipmentType.EquipmentTypeCode.search('OT') !== -1 || shipmentsDetails.EquipmentType.EquipmentTypeCode.search('FL') !== -1 ? true : false,
                // 'DangerousGoodsId': shipments?.DangerousGoods?.Id,
                // 'DangerousGoodsCode': shipments?.DangerousGoods?.Code,
                // 'DangerousGoodsClass': shipments?.DangerousGoods?.Class,
                'EquipmentId': shipmentsDetails?.Equipment?.Id,
                'Prefix': shipmentsDetails?.Equipment?.Prefix,
                'Number': shipmentsDetails?.Equipment?.Number,
                'CheckDigit': shipmentsDetails?.Equipment?.CheckDigit,
                'Tare': shipmentsDetails?.Equipment?.Tare || shipmentsDetails.EquipmentType.EquipmentTypeTareWeight || '',
                'Payload': shipmentsDetails?.Equipment?.Payload || '',
                'equipmentNumber': `${shipmentsDetails?.Equipment?.Prefix} ${shipmentsDetails?.Equipment?.Number} ${shipmentsDetails?.Equipment?.CheckDigit}`,
                'DimensionsId': shipmentsDetails.BookingEquipmentDimensionsList[0]?.Id,
                'DimensionsWidth': shipmentsDetails.BookingEquipmentDimensionsList[0]?.DimensionsWidth,
                'DimensionsHeight': shipmentsDetails.BookingEquipmentDimensionsList[0]?.DimensionsHeight,
                'DimensionsLength': shipmentsDetails.BookingEquipmentDimensionsList[0]?.DimensionsLength,
                'CommodityId': shipments.Shipment?.IdCommodity,
                'CommodityCode': shipments.Shipment?.CommodityCode,
                'CommodityName': shipments.Shipment?.CommodityName,
                'Equipment': tempEquipment,
                // 'shipmentChanged': deRetardLabels([...(tempMap.get(shipments.Shipment.Id || '0') || []), ...bookingEquipmentchanges(tempMap.get(shipmentsDetails.BookingEquipment.Id || '0') || []), ...(tempMap.get(shipmentsDetails?.Equipment?.Id || '0') || []), ...getAllDimensions(shipmentsDetails.BookingEquipmentDimensionsList, tempMap)]),
                'shipmentChanged': [...deRetardLabels(tempMap.get(shipments.Shipment.Id || '0') || [], 'Shipment'), ...bookingEquipmentchanges(tempMap.get(shipmentsDetails.BookingEquipment.Id || '0') || []), ...deRetardLabels(tempMap.get(shipmentsDetails?.Equipment?.Id || '0') || []), ...getAllDimensions(shipmentsDetails.BookingEquipmentDimensionsList, tempMap)],
                'dangerousGoods': shipments.ShipmentDangerousGoodsPlusList.map((imo, imoIndex) => {
                  return {
                    'id': imoIndex + 1,
                    'IdDangerousGoodsList': imo.ShipmentDangerousGoods.Id,
                    'DangerousGoodsId': imo.ShipmentDangerousGoods.IdDangerousGoods,
                    'FlashPT': imo.ShipmentDangerousGoods.FlashPT,
                    'PackagingGroup': imo.ShipmentDangerousGoods.PackagingGroup,
                    'DangerousGoodsCode': imo.DangerousGoods.Code,
                    'DangerousGoodsClass': imo.DangerousGoods.Class,
                    'shipmentChanged': [...(tempMap.get(imo?.ShipmentDangerousGoods?.Id || '0') || [])],
                  }
                })
              }
              if (tempObj.bookingEquipmentStatus === 'D') {
              }
              shipmentsDetails.BookingEquipmentDimensionsList.forEach(dimension => {
                if (dimension.DimensionsCode === 'FRO') {
                  tempObj.Front = dimension.DimensionsLength || 0
                  tempObj.DimensionsFROId = dimension.Id
                }
                if (dimension.DimensionsCode === 'BAC') {
                  tempObj.Back = dimension.DimensionsLength || 0
                  tempObj.DimensionsBACId = dimension.Id
                }
                if (dimension.DimensionsCode === 'LEF') {
                  tempObj.Left = dimension.DimensionsWidth || 0
                  tempObj.DimensionsLEFId = dimension.Id
                }
                if (dimension.DimensionsCode === 'RIG') {
                  tempObj.Right = dimension.DimensionsWidth || 0
                  tempObj.DimensionsRIGId = dimension.Id
                }
                if (dimension.DimensionsCode === 'OVE') {
                  tempObj.Height = dimension.DimensionsHeight || 0
                  tempObj.DimensionsOVEId = dimension.Id
                }
              })
              if (tempObj.Equipment === 'no') {
                const newTempArray = []
                let tempBool = false
                tempArrayObj.forEach(obj => {
                  if (obj.EquipmentIndex === tempObj.EquipmentIndex) {
                    tempBool = true
                    if (!newTempArray.some(test => test.id === tempObj.id) && obj.id !== tempObj.id) {
                      newTempArray.push(tempObj)
                      newTempArray.push(obj)
                    } else {
                      newTempArray.push(obj)
                    }
                  } else {
                    newTempArray.push(obj)
                  }
                })
                if (tempBool === false) {
                  newTempArray.push(tempObj)
                }

                tempArrayObj = newTempArray
              } else {
                tempArrayObj.push(tempObj)
              }
            })
            if (shipments.ShipmentDetailPlusList.length === 0) {
              masterIndex++
              tempEquipmentIndex++
              const bareObj = {
                'id': masterIndex,
                'Quantity': '1',
                'shipOrder': shipments.Shipment.Order,
                'shipTransOrder': shipments.Shipment.TransportKey,
                'shipmentStatus': shipments.Shipment.DbStatus,
                'shipmentDetailsStatus': null,
                'bookingEquipmentStatus': null,
                'ShipmentId': shipments.Shipment.Id,
                'ShipmentDetailsId': null,
                'bookingEquipmentId': null,
                'EquipmentIndex': tempEquipmentIndex,
                'EquipmentTypeId': '',
                'Equipment Type': '',
                'Shipment': shipments.Shipment.TransportKey,
                'IMO': shipments.Shipment.IMODangerGoods || false,
                'FlashPT': shipments.Shipment.FlashPT ? shipments.Shipment.FlashPT : '',
                'PackagingGroup': shipments.Shipment.PackingGroup ? shipments.Shipment.PackingGroup : '',
                'temp': shipments.Shipment.Temp,
                'onOff': shipments.Shipment.Temp !== 0 && shipments.Shipment.Temp !== undefined && shipments.Shipment.Temp !== null,
                'CommodityId': shipments.Shipment?.IdCommodity,
                'CommodityCode': shipments.Shipment?.CommodityCode,
                'CommodityName': shipments.Shipment?.CommodityName,
                'Equipment': 'yes',
                'shipmentChanged': [...deRetardLabels(tempMap.get(shipments.Shipment.Id || '0') || [], 'Shipment')],
                'dangerousGoods': shipments.ShipmentDangerousGoodsPlusList.map((imo, imoIndex) => ({
                  'id': imoIndex + 1,
                  'IdDangerousGoodsList': imo.ShipmentDangerousGoods.Id,
                  'DangerousGoodsId': imo.ShipmentDangerousGoods.IdDangerousGoods,
                  'FlashPT': imo.ShipmentDangerousGoods.FlashPT,
                  'PackagingGroup': imo.ShipmentDangerousGoods.PackagingGroup,
                  'DangerousGoodsCode': imo.DangerousGoods.Code,
                  'DangerousGoodsClass': imo.DangerousGoods.Class,
                  'shipmentChanged': [...(tempMap.get(imo?.ShipmentDangerousGoods?.Id || '0') || [])],
                }))
              }
              tempArrayObj.push(bareObj)
            }
            // setShipmentArray(prev => [...prev, shipIndex + 1])
          })
          // console.log(tempArrayObj)
          tempArrayObj.forEach(obj => {
            if (!tempShipmentArray.includes(obj.Shipment)) {
              tempShipmentArray.push(obj.Shipment)
            }
          })
          wasEdited([...(tempMap.get(data.Booking.Id || '0') || [])])

          tempArrayObj.sort((a, b) => a.shipOrder === b.shipOrder ? a.shipTransOrder - b.shipTransOrder : a.shipOrder - b.shipOrder)

          // tempShipmentArray.sort((a, b) => a - b)
          setShipmentArray(tempShipmentArray)
          setShipmentObjArray(tempArrayObj)

          // Load BookingEquipments (Equipment / Park Code / Terminal Codes table)
          bookingEquipmentService.filter(`/byBooking/${lineId}`).then(beResponse => {
            const beItems = Array.isArray(beResponse) ? beResponse : (beResponse?.Items || [])
            const meaningful = (beItems || []).filter(be =>
              be.EquipmentId ||
              be.ContainerControlEquipmentId ||
              be.IdParkLocation ||
              be.IdTerminalLoadLocation ||
              be.IdTerminalDischargeLocation ||
              be.BookingDate ||
              be.GateDate
            )
            if (meaningful.length > 0) {
              const mapped = meaningful.map((be, idx) => ({
                id: idx + 1,
                beId: be.Id,
                sdId: be.ShipmentDetailId || null,
                ccEquipmentId: be.ContainerControlEquipmentId || null,
                ccEquipmentTypeId: be.ContainerControlEquipmentTypeId || null,
                Shipment: be.ShipmentTransportKey || 1,
                EquipmentIndex: idx + 1,
                EquipmentType: `${be.EquipmentTypeLenght || ''}${be.EquipmentTypeCode || ''}`,
                EquipmentTypeCode: be.EquipmentTypeCode || '',
                EquipmentNumber: '',
                ParkCode: be.ParkLocationCode || '',
                ParkCodeId: be.IdParkLocation || null,
                TerminalLoadLocation: be.TerminalLoadLocationCode || '',
                TerminalLoadLocationId: be.IdTerminalLoadLocation || null,
                TerminalDischargeLocation: be.TerminalDischargeLocationCode || '',
                TerminalDischargeLocationId: be.IdTerminalDischargeLocation || null,
                BookingDate: be.BookingDate || '',
                GateDate: be.GateDate || '',
              }))
              setBookingEquipmentArray(mapped)
              mapped.forEach((item, index) => {
                if (!item.EquipmentType && item.ccEquipmentTypeId) {
                  containerEquipmentTypeService.filter(`/byExternalId/${item.ccEquipmentTypeId}`)
                    .then(res => {
                      const ccType = Array.isArray(res) ? res[0] : res
                      if (ccType && ccType.name !== 'AxiosError') {
                        setBookingEquipmentArray(prev => {
                          const next = [...prev]
                          if (next[index]) next[index] = { ...next[index], EquipmentType: ccType.Code || '', EquipmentTypeCode: ccType.Code || '' }
                          return next
                        })
                      }
                    }).catch(() => {})
                }
                if (!item.ccEquipmentId) return
                containerEquipmentService.filter(`/byExternalId/${item.ccEquipmentId}`)
                  .then(res => {
                    const eq = Array.isArray(res) ? res[0] : res
                    if (eq && eq.name !== 'AxiosError') {
                      setBookingEquipmentArray(prev => {
                        const next = [...prev]
                        if (next[index]) {
                          next[index] = {
                            ...next[index],
                            EquipmentNumber: `${eq.Prefix || ''} ${eq.Number || ''} ${eq.CheckDigit || ''}`.trim(),
                          }
                        }
                        return next
                      })
                    }
                  }).catch(() => {})
              })
            }
          }).catch(() => {})

          const bookingNumber = dataBooking.BookingNumber
          if (bookingNumber) {
            shipmentChargesService.filter(`/queryByBooking?booking_number=${bookingNumber}`)
              .then(chargesData => {
                if (chargesData && !chargesData.name) {
                  setShipmentChargesArray(Array.isArray(chargesData) ? chargesData : (chargesData?.value || []))
                }
              })
          }

          setIsLoaded(false)
          ctx.setIsLoad(false)
        })
      })
    })
  }

  useEffect(() => {
    if (chargesRefreshTick === 0) return
    const bookingNumber = extraValues.get('BookingNumber')
    if (bookingNumber) {
      shipmentChargesService.filter(`/queryByBooking?booking_number=${bookingNumber}`)
        .then(chargesData => {
          if (chargesData && !chargesData.name) {
            setShipmentChargesArray(Array.isArray(chargesData) ? chargesData : (chargesData?.value || []))
          }
        })
    }
  }, [chargesRefreshTick])

  const getAllDimensions = (dimensions, changesMap) => {
    if (dimensions.length > 1) {

      const newArray = []
      dimensions.forEach(elem => {
        if (elem.DimensionsCode === 'FRO') {
          if (changesMap?.get(elem.Id)?.includes('DimensionsLength')) newArray.push('Front')
        }
        if (elem.DimensionsCode === 'BAC') {
          if (changesMap?.get(elem.Id)?.includes('DimensionsLength')) newArray.push('Back')
        }
        if (elem.DimensionsCode === 'LEF') {
          if (changesMap?.get(elem.Id)?.includes('DimensionsWidth')) newArray.push('Left')
        }
        if (elem.DimensionsCode === 'RIG') {
          if (changesMap?.get(elem.Id)?.includes('DimensionsWidth')) newArray.push('Right')
        }
        if (elem.DimensionsCode === 'OVE') {
          if (changesMap?.get(elem.Id)?.includes('DimensionsHeight')) newArray.push('Height')
        }
      })
      return newArray
    }
    if (dimensions.length === 1) {
      return changesMap.get(dimensions[0].Id) || []
    }
    if (dimensions.length === 0) {
      return []
    }
    return []
  }

  const bookingEquipmentchanges = (newList) => {
    const tempList = []
    newList.forEach(el => {
      switch (el) {
        case 'Id':
          tempList.push('bookingEquipmentId')
          break
        case 'GoodsDetails':
          tempList.push('Cargo Description')
          break
        case 'TransportDetails':
          tempList.push('Load Weight (KG)')
          break
        case 'LoadingDate':
          tempList.push('Loading Date')
          break
        case 'IMODangerGoods':
          tempList.push('IMO')
          break
        case 'Temp':
          tempList.push('temp')
          break
        default:
          tempList.push(el)
      }
    })
    return tempList
  }

  const deRetardLabels = (newList, type) => {
    const tempList = []
    newList.forEach(el => {
      switch (el) {
        case 'IMODangerGoods':
          tempList.push('IMO')
          break
        case 'Temp':
          tempList.push('temp')
          break
        default:
          if (type === 'Shipment' && el === 'Id') {
            tempList.push('ShipmentId')
          } else {
            tempList.push(el)
          }
      }
    })
    return tempList
  }

  const wasEdited = (newList) => {
    const tempList = []
    newList.forEach(el => {
      tempList.push(el)
    })
    setChangedList(tempList)
  }

  const addRejectFields = (e, key, dict) => {
    if (e.target.checked === true) {
      setRejectFields(prev => [...prev, { 'key': key, 'value': dict?.get(key), 'notes': '' }])
      setIsChecked(prev => [...prev, key])
    }
    else {
      setRejectFields(rejectFields.filter(obj => obj.key !== key))
      setIsChecked(isChecked.filter(obj => obj !== key))
    }
  }

  const addValue = (key, value, dict, setDict) => {
    // console.log("key", key)
    // console.log("value", value)
    if (key === 'Original Port') {
      if (value !== "") {
        dict.set("Transhipment", true)
      }
      else {
        dict.set("Transhipment", false)
      }
    }
    if (typeof value === 'string' || value instanceof String) {
      value = value.toLocaleUpperCase()
    }
    dict.set(key, value)
    setDict(new Map(dict))
  }

  const handleCloseConfirmModal = () => {
    setOpenConfirmModal(false)
  }

  const showForm = (n) => {
    switch (n) {
      case 1:
        setFormVoyage(true)
        setFormEntities(false)
        setFormPortsLocations(false)
        // setFormDetails(false)
        setFormEquipments(false)
        break
      case 2:
        setFormVoyage(false)
        setFormEntities(true)
        setFormPortsLocations(false)
        // setFormDetails(false)
        setFormEquipments(false)
        break
      case 3:
        setFormVoyage(false)
        setFormEntities(false)
        setFormPortsLocations(true)
        // setFormDetails(false)
        setFormEquipments(false)
        break
      case 4:
        setFormVoyage(false)
        setFormEntities(false)
        setFormPortsLocations(false)
        // setFormDetails(true)
        setFormEquipments(false)
        break
      case 5:
        setFormVoyage(false)
        setFormEntities(false)
        setFormPortsLocations(false)
        // setFormDetails(false)
        setFormEquipments(true)
        break
      default:
        return null
    }
  }

  const toLocal = (date) => {
    const local = new Date(date)
    local.setMinutes(date.getMinutes() - date.getTimezoneOffset())
    return local.toJSON()
  }

  const dataToUpdate = () => {
    let today = new Date()
    let todayFormat = toLocal(today)
    let errorMessage = ''
    let isError = false

    if (!entitiesDict.get('InvoiceCode')) {
      toastMessages('error', '', t('invoiceEmpty'))
      ctx.setIsLoad(false)
      return
    }

    if (!locationsDict.get('Discharge Port') || !locationsDict.get('Loading Port')) {
      toastMessages('error', '', t('locationsEmpty'))
      ctx.setIsLoad(false)
      return
    }

    const tempObj = {

      'Date': todayFormat,
      'TransportId': extraValues.get('transport id'),
      'LocationReceiptId': extraValues.get('Original Port id'),
      'LoadingPortId': extraValues.get('Loading Port id'),
      'DischargePortId': extraValues.get('Discharge Port id'),
      'LocationDeliveryPortId': extraValues.get('Final Port id'),
      'ClientId': extraValues.get('Client Id'),
      'ProcessStatusId': extraValues.get('Waiting for Approval id'),
      'InvoiceId': extraValues.get('InvoiceId'),
      'IdInvoice': extraValues.get('InvoiceId'),
      'VesselCode': voyageDict.get('Vessel'),
      'VoyageNumber': voyageDict.get('Voyage'),
      'ClientCode': entitiesDict.get('ClientCode'),
      'ClientVAT': entitiesDict.get('ClientVAT'),
      'ClientReference': entitiesDict.get('ClientReference'),
      'InvoiceCode': entitiesDict.get('InvoiceCode'),
      'InvoiceVAT': entitiesDict.get('InvoiceVAT'),
      'OriginalPortCode': locationsDict.get('Original Port Code'),
      'LoadingPortCode': locationsDict.get('Loading Port Code'),
      'DischargePortCode': locationsDict.get('Discharge Port Code'),
      'FinalPortCode': locationsDict.get('Final Port Code'),
      'Transhipment': locationsDict.get('Transhipment') === true ? 'Y' : 'N',
      // 'QuoteNumber': detailsDict.get('Quote Number'),
      'QuoteId': linkedQuoteId,

      'ProcessKey': null,
      'BookingNumber': extraValues.get('BookingNumber'),
      'AccountingA': null,
      'Mrn': adminDict.get('Mrn') || null,
      'Comments': null,
      'IncotermsId': adminDict.get('IncotermsId') || null,
      'IncotermsCode': adminDict.get('IncotermsCode') || null,
      'NotifyId': adminDict.get('NotifyId') || null,
      'AgentId': adminDict.get('AgentId') || null,
      'ShipperId': adminDict.get('ShipperId') || null,
      'CurrencyId': adminDict.get('CurrencyId') || null,
      'ConsigneeId': adminDict.get('ConsigneeId') || null,
      'SubAccountId': adminDict.get('SubAccountId') || null,
      'CustomStatusId': adminDict.get('CustomStatusId') || null,
      'ExternalLineId': adminDict.get('ExternalLineId') || null,
      'ShippingConditionId': adminDict.get('ShippingConditionId') || null,
      'PreCarriagePortId': adminDict.get('PreCarriageId') || null,
      'OnCarriagePortId': adminDict.get('OnCarriageId') || null,
      'SecondTransportId': adminDict.get('SecondTransportId') || null,
      'BLNumber': adminDict.get('BLNumber') || null,
      'DocumentQuantity': adminDict.get('DocumentQuantity') ?? null,
      'UserCompanyId': extraValues.get('UserCompanyId')

      // 'DischargePortId':null
    }

    const shipments = new Map()
    shipmentArray.forEach(ship => {
      shipments.set(ship, [])
    })
    shipmentObjArray.forEach(data => {
      if (data.shipmentDetailsStatus === 'D' || data.shipmentStatus === 'D' || data.bookingEquipmentStatus === 'D') {
        return
      }
      shipments.set(data.Shipment, shipments.get(data.Shipment) !== undefined ? [...shipments.get(data.Shipment), data] : [data])
    })
    let newPost = { Booking: { ...tempObj, 'Id': extraValues.get('id') } }
    const ShipmentPlus = []
    let ShipmentDetailPlus = []

    // Identify bottom-table BEs (park/terminal/CC-only) that are not already covered
    // by the top-table rows in shipmentObjArray. These must be included in the payload
    // so ViewBookingService.Update() does not soft-delete them.
    const topTableBeIds = new Set(shipmentObjArray.map(s => s.bookingEquipmentId).filter(Boolean))
    const bottomTableBesByShipment = new Map()
    bookingEquipmentArray.forEach(be => {
      if (topTableBeIds.has(be.beId)) return
      const key = be.Shipment
      if (!bottomTableBesByShipment.has(key)) bottomTableBesByShipment.set(key, [])
      bottomTableBesByShipment.get(key).push(be)
    })

    let Shipment
    let NewShipment
    shipmentArray.forEach(index => {
      if (shipments.get(index).length === 0) {
        return
      }

      Shipment = {
        Id: shipments.get(index)[0].ShipmentId,
        IdBooking: extraValues.get('id'),
        DangerousGoodsId: shipments.get(index)[0].DangerousGoodsId !== undefined ? shipments.get(index)[0].DangerousGoodsId : null,
        FlashPT: shipments.get(index)[0].FlashPT,
        Temp: shipments.get(index)[0].temp,
        IdPackage: null,
        IdCommodity: shipments.get(index)[0].CommodityId !== undefined ? shipments.get(index)[0].CommodityId : null,
        IMODangerGoods: shipments.get(index)[0].IMO,
      }

      let ShipmentDangerousGoods = []
      if (shipments.get(index)[0].dangerousGoods && shipments.get(index)[0].IMO) {

        ShipmentDangerousGoods = shipments.get(index)[0].dangerousGoods.map((imo, imoIndex) => {
          return {
            'ShipmentDangerousGoods': {
              'Id': imo.IdDangerousGoodsList,
              'IdShipment': shipments.get(index)[0].ShipmentId,
              'IdDangerousGoods': imo.DangerousGoodsId,
              'FlashPT': imo.FlashPT,
              'PackagingGroup': imo.PackagingGroup,
            }
          }

        }
        )
      }


      if (shipments.get(index)[0].Reefer) {
        if ((shipments.get(index)[0].onOff !== false && shipments.get(index)[0].onOff !== true) || (shipments.get(index)[0].onOff && !shipments.get(index)[0].temp)) {

          isError = true
          errorMessage = t("tempEmpty")
        }
      }

      ShipmentDetailPlus = []
      shipments.get(index).forEach(shipment => {

        const beData = bookingEquipmentArray.find(be => be.beId === shipment.bookingEquipmentId)
        const ShipmentDetails = {
          ShipmentDetail: {
            Id: shipment.ShipmentDetailsId,
            IdBookingEquipment: shipment.bookingEquipmentId,
            IdShipment: shipment.ShipmentId,
            Package: shipment.NrPackage,
            Description: shipment.Description,
            Weight: shipment.Weight,
            Measures: shipment.Measures,
          },
          BookingEquipment: {
            Id: shipment.bookingEquipmentId,
            LoadingDate: shipment['Loading Date'].replace('-', '/'),
            SOC: shipment.SOC === true ? 'Y' : 'N',
            GoodsDetails: shipment['Cargo Description'],
            TransportDetails: shipment['Load Weight (KG)'],
            Brand: shipment.Brand,
            Model: shipment.Model,
            Chassis: shipment.Chassis,
            IdEquipment: shipment.EquipmentId,
            IdEquipmentType: shipment.EquipmentTypeId,
            IdEquipmentOwnerAccount: null,
            IdParkLocation: beData?.ParkCodeId || null,
            IdTerminalLoadLocation: beData?.TerminalLoadLocationId || null,
            IdTerminalDischargeLocation: beData?.TerminalDischargeLocationId || null,
            BookingDate: beData?.BookingDate || null,
            GateDate: beData?.GateDate || null,
          },
          BookingEquipmentDimensionsList: []
        }

        if (!shipment['Load Weight (KG)']) {
          isError = true
          errorMessage = t("LoadWeightEmpty") || "Load Weight is required"
        }

        if (shipment.RORO) {
          if (!shipment.Brand || !shipment.Model || !shipment.Chassis) {
            isError = true
            errorMessage = t("ROROEmpty")
          }
        }

        if (!shipment['Cargo Description']) {
          isError = true
          errorMessage = t("CargoDescriptionEmpty") || "Cargo Description is required"
        }

        if (shipment.DimensionsHeight || shipment.DimensionsWidth || shipment.DimensionsLength) {
          ShipmentDetails.BookingEquipmentDimensionsList = [
            {
              // Id: shipment.DimensionsId,
              BookingEquipmentId: '00000000-0000-0000-0000-000000000000',
              DimensionsWidth: shipment.DimensionsWidth || 0,
              DimensionsHeight: shipment.DimensionsHeight || 0,
              DimensionsLength: shipment.DimensionsLength || 0,
            }
          ]
        }
        if (shipment?.Front || shipment?.Back || shipment?.Left || shipment?.Right || shipment?.Height) {
          ShipmentDetails.BookingEquipmentDimensionsList = [
            {
              BookingEquipmentId: shipment.bookingEquipmentId || "00000000-0000-0000-0000-000000000000",
              DimensionsCode: 'FRO',
              DimensionsLength: shipment?.Front || 0,
              DimensionsWidth: 0,
              DimensionsHeight: 0,
            },
            {
              BookingEquipmentId: shipment.bookingEquipmentId || "00000000-0000-0000-0000-000000000000",
              DimensionsCode: 'BAC',
              DimensionsLength: shipment?.Back || 0,
              DimensionsWidth: 0,
              DimensionsHeight: 0,
            },
            {
              BookingEquipmentId: shipment.bookingEquipmentId || "00000000-0000-0000-0000-000000000000",
              DimensionsCode: 'LEF',
              DimensionsLength: 0,
              DimensionsWidth: shipment?.Left || 0,
              DimensionsHeight: 0,
            },
            {
              BookingEquipmentId: shipment.bookingEquipmentId || "00000000-0000-0000-0000-000000000000",
              DimensionsCode: 'RIG',
              DimensionsLength: 0,
              DimensionsWidth: shipment?.Right || 0,
              DimensionsHeight: 0,
            },
            {
              BookingEquipmentId: shipment.bookingEquipmentId || "00000000-0000-0000-0000-000000000000",
              DimensionsCode: 'OVE',
              DimensionsLength: 0,
              DimensionsWidth: 0,
              DimensionsHeight: shipment?.Height || 0,
            },
          ]
        }
        if (shipment.SOC) {
          if (!shipment.Number || !shipment.CheckDigit) {
            isError = true
            errorMessage = t("SOCEmpty")
          }
        }
        if (shipment.Number) {
          ShipmentDetails.Equipment = {
            Id: shipment.EquipmentId || '00000000-0000-0000-0000-000000000000',
            Prefix: shipment.Prefix,
            Number: shipment.Number,
            CheckDigit: shipment.CheckDigit,
            IdEquipmentType: shipment.EquipmentTypeId || null,
            Tare: shipment.Tare,
            SOC: shipment.SOC,
            Payload: shipment?.Payload
          }
        }

        ShipmentDetailPlus.push(ShipmentDetails)

      })

      // Include bottom-table BEs (park/terminal/CC-only) so they survive the update
      ;(bottomTableBesByShipment.get(index) || []).forEach(be => {
        ShipmentDetailPlus.push({
          ShipmentDetail: {
            Id: be.sdId || '00000000-0000-0000-0000-000000000000',
            IdBookingEquipment: be.beId,
            IdShipment: shipments.get(index)[0]?.ShipmentId,
          },
          Equipment: null,
          BookingEquipment: {
            Id: be.beId,
            ContainerControlEquipmentTypeId: be.ccEquipmentTypeId || null,
            ContainerControlEquipmentId: be.ccEquipmentId || null,
            IdParkLocation: be.ParkCodeId || null,
            IdTerminalLoadLocation: be.TerminalLoadLocationId || null,
            IdTerminalDischargeLocation: be.TerminalDischargeLocationId || null,
            BookingDate: be.BookingDate || null,
            GateDate: be.GateDate || null,
            Brand: '',
            Model: '',
            Chassis: '',
            SOC: 'N',
            GoodsDetails: '',
            TransportDetails: '',
          },
          BookingEquipmentDimensionsList: []
        })
      })

      NewShipment = { "ShipmentDangerousGoodsPlusList": ShipmentDangerousGoods, Shipment, 'ShipmentDetailPlusList': ShipmentDetailPlus }
      ShipmentPlus.push(NewShipment)
    })
    newPost = { ...newPost, ShipmentPlusList: ShipmentPlus }
    // console.log(newPost)
    if (isError) {
      ctx.setIsLoad(false)
      toastMessages('error', '', errorMessage)
      return
    }
    return newPost
  }

  const submitedReproval = () => {
    ctx.setIsLoad(true)
    let values = new Map()
    values.set("RejectFields", rejectFields)
    values.set("ReprovedRows", reprovedRows)
    values.set("Notes", finalNotes)
    values = Object.fromEntries(values)
    const valueString = JSON.stringify(values)
    const temp = btoa(valueString)

    let tempString = '\n FIELDS REJECTED:  \n'

    rejectFields.forEach(field => {
      tempString = tempString.concat(`\n${field.key} ${field?.value ? ':' + field?.value : ''}- \n \xa0 ${field.notes} \n`)
    })

    if (reprovedRows.length > 0) {
      tempString = tempString.concat(`\n  Equipments Rejected:  \n\n`)
      reprovedRows?.forEach(row => {
        tempString = tempString.concat(`Line id ${row.id} - Type: ${row['Equipment Type']} - Description: ${row['Cargo Description']} - Weight: ${row['Load Weight (KG)']} \n`)
      })
    }

    tempString = tempString.concat(`\n  NOTES:  \n \xa0 ${finalNotes}`)
    let data = dataToUpdate()
    if (!data) {
      return
    } else {
      const approvalPost = {
        "IdBooking": data.Booking.Id,
        "IdBL": null,
        "Approved": false,
        // "EquipmentId":
        "Description": temp,
        "NotificationBody": tempString,
      }
      data.Booking.ProcessStatusId = reject

      bookingV2Service.update(`${data.Booking.Id}`, data).then(responseBooking => {
        let success = true
        if (responseBooking.name === 'AxiosError') {
          toastMessages('error', '', responseBooking.response.data.Message || responseBooking.message)
          success = false
        }
        if (success) {
          approveService.post(approvalPost).then(response => {
            ctx.setIsLoad(false)
            // setApproveSuccess(true)
            if (response.name === 'AxiosError') {
              toastMessages('error', '', response.message)
              success = false
            }
            setIsApprove(false)
            setApproveSuccess(success)
            setConfirmationModal(true)
          })
        } else {
          ctx.setIsLoad(false)
          setIsApprove(false)
          setApproveSuccess(success)
          setConfirmationModal(true)
        }
      })
    }
  }

  const submitedApproval = () => {
    ctx.setIsLoad(true)
    let values = new Map()
    values.set("RejectFields", rejectFields)
    values.set("ReprovedRows", reprovedRows)
    values.set("Notes", finalNotes)
    values = Object.fromEntries(values)
    const valueString = JSON.stringify(values)
    const temp = btoa(valueString)

    let data = dataToUpdate()
    const approvalPost = {
      "IdBooking": data.Booking.Id,
      "IdBL": null,
      "Approved": true,
      "Description": "Approved",
      "NotificationBody": ""
    }

    data.Booking.ProcessStatusId = accept

    bookingV2Service.update(`${data.Booking.Id}`, data).then(responseBooking => {
      let success = true
      if (responseBooking.name === 'AxiosError') {
        toastMessages('error', '', responseBooking.response.data.Message || responseBooking.message)
        success = false
      }
      if (success) {
        approveService.post(approvalPost).then(response => {
          ctx.setIsLoad(false)
          if (response.name === 'AxiosError') {
            toastMessages('error', '', response.message)
            success = false
            setErrorMessage(response.response.data.Errors)
          }
          setIsApprove(true)
          setApproveSuccess(success)
          setConfirmationModal(true)
        })
      } else {
        ctx.setIsLoad(false)
        setIsApprove(true)
        setApproveSuccess(success)
        setConfirmationModal(true)
      }
    })
  }

  const confirmApproval = () => {
    setConfirmationModal(false)
    toastMessages('success', '', t("MessageRedirectingMenu"))
    handleTabClose(JSON.parse(id))
  }

  const closeModal = () => {
    setConfirmationModal(false)
  }

  const rejectFieldsNotes = (obj, notes) => {
    setRejectFields(rejectFields.map(elem => {
      if (elem.key === obj.key) {
        return { ...elem, 'notes': notes }
      }
      return elem
    }))
  }

  const submitForApproval = () => {

    setOpenConfirmModal(true)
    setRadioButton("Wrong fields")
  }

  const onReprove = (obj, data) => {
    setReprovedRows(reprovedRows.map(elem => {
      if (elem.id === obj.id) {
        return { ...obj, 'Notes': data }
      } else {
        return elem
      }
    }))
  }

  const getAccountCompany = (tempId) => {

    if (tempId) {
      accountService.getId(tempId).then(responseAccount => {
        addValue('ClientCode', responseAccount.AccountCode, entitiesDict, setEntitiesDict)
        addValue('ClientVAT', responseAccount.AccountVATNumber, entitiesDict, setEntitiesDict)
        addValue('Client Id', responseAccount.Id, extraValues, setExtraValues)
      })
    } else {
      addValue('ClientCode', '', entitiesDict, setEntitiesDict)
      addValue('ClientVAT', '', entitiesDict, setEntitiesDict)
      addValue('Client Id', '', extraValues, setExtraValues)
    }
  }

  const functionLeavingPage = () => {
    ctx2.closeTab(JSON.parse(id))
  }

  return (
    <>
      {isLoaded ? (<LoadingBar />) : (
        (<SimpleApproveBooking
          id={id}
          valueTimeline={valueTimeline}
          submitForApproval={submitForApproval}
          t={t}
          submitedApproval={submitedApproval}
          voyage={voyage}
          voyageDict={voyageDict}
          addValue={addValue}
          setVoyageDict={setVoyageDict}
          entities={entities}
          isChecked={isChecked}
          addRejectFields={addRejectFields}
          entitiesDict={entitiesDict}
          setEntitiesDict={setEntitiesDict}
          portsLocations={portsLocations}
          locationsDict={locationsDict}
          shipmentObjArray={shipmentObjArray}
          setShipmentObjArray={setShipmentObjArray}
          setLocationsDict={setLocationsDict}
          openConfirmModal={openConfirmModal}
          handleCloseConfirmModal={handleCloseConfirmModal}
          setRadioButton={setRadioButton}
          radioButton={radioButton}
          rejectFields={rejectFields}
          rejectFieldsNotes={rejectFieldsNotes}
          finalNotes={finalNotes}
          setFinalNotes={setFinalNotes}
          setDefaultBooking={setDefaultBooking}
          openDrawer={openDrawer}
          setOpenDrawer={setOpenDrawer}
          selectedLine={selectedLine}
          setSelectedLine={setSelectedLine}
          reprovedRows={reprovedRows}
          setReprovedRows={setReprovedRows}
          extraValues={extraValues}
          setExtraValues={setExtraValues}
          submitedReproval={submitedReproval}
          getAccountCompany={getAccountCompany}
          companies={companies}
          confirmationModal={confirmationModal}
          setConfirmationModal={setConfirmationModal}
          confirmApproval={confirmApproval}
          closeModal={closeModal}
          approveSuccess={approveSuccess}
          isApprove={isApprove}
          extraValuesArray={extraValuesArray}
          toastMessages={toastMessages}
          drawerName={drawerName}
          setDrawerName={setDrawerName}
          errorMessage={errorMessage}
          changedList={changedList}
          bookingLine={bookingLine}
          draft={draft}
          shipmentArray={shipmentArray}
          setShipmentArray={setShipmentArray}
          ctx={ctx}
          leavingPage={leavingPage}
          setLeavingPage={setLeavingPage}
          functionLeavingPage={functionLeavingPage}
          onReprove={onReprove}
          fieldsInDrawerEquipment={fieldsInDrawerEquipment}
          fieldsInDrawerShipment={fieldsInDrawerShipment}
          equipmentDict={equipmentDict}
          setEquipmentDict={setEquipmentDict}
          shipmentChargesArray={shipmentChargesArray}
          isAdmin={isAdmin}
          onRefreshCharges={refreshShipmentCharges}
          bookingEquipmentArray={bookingEquipmentArray}
          adminDict={adminDict}
          setAdminDict={setAdminDict}
          processDetailsDict={processDetailsDict}
          setProcessDetailsDict={setProcessDetailsDict}
        />)
      )}
    </>
  )
}
